// import { FORMDATA } from "constants/Data";
import { FC } from "react";
import styles from "./index.module.scss";
import { IntegrationLayoutProps } from "./types";
import IntegrationSidebar from "components/Global/IntegrationSidebar";

// Integration menu page layout component
const IntegrationLayout: FC<IntegrationLayoutProps> = (props) => {
  // Initialize variables and props
  // const { previewIntegrationMenuItems } = FORMDATA;
  const { children, onSideBarChange, selectedSidebar,sidebarMenu } = props;

  // JSX
  return (
    <div className={styles["settings-layout"]}>
      <div className={styles["settings-layout__wrapper"]}>
        <IntegrationSidebar
          items={sidebarMenu}
          handleSidebar={onSideBarChange}
          selectedSidebar={selectedSidebar as string}
        />
        <div className={styles["settings-layout__body"]}>{children}</div>
      </div>
    </div>
  );
};

export default IntegrationLayout;
